import React from 'react';
import { connect } from 'react-redux';
import ReactEcharts from '../lazy/Echarts';
import { ECHARTS_COLORS } from '../../redux/constants/colors';
import { graphDateString } from '../../utils/parsing';
import { zip } from '../../utils/collections';
import './heartbeats-graph.css';

const getOption = ({ timestamps, labels, series }) => ({
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal',
    data: labels,
    top: '90%',
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '10%',
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    boundaryGap: false,
    data: timestamps,
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
    },
    {
      type: 'value',
      position: 'right',
      name: 'Celsius',
    },
  ],
  color: ECHARTS_COLORS,
  series,
});

const HeartbeatsGraph = (props) =>
  props.isEmpty ? null : (
    <span className="heartbeat-graph">
      <ReactEcharts option={getOption(props)} notMerge style={{ height: '250px' }} />
    </span>
  );

export default connect(
  (
    {
      entities: {
        deployments: { heartbeats },
      },
    },
    { deployment }
  ) => {
    const siteBeats = heartbeats[deployment.site] || [];
    const timestamps = siteBeats.map((s) => graphDateString(s.timestamp));
    timestamps.sort();
    const makeData = (prop) =>
      zip(
        timestamps,
        siteBeats.map((s) => s[prop])
      );
    const series = [
      { name: '1 min load', type: 'line', data: makeData('load_1m') },
      { name: '5 min load', type: 'line', data: makeData('load_5m') },
      { name: '15 min load', type: 'line', data: makeData('load_15m') },
      { name: 'Disk Usage', type: 'line', data: makeData('disk_usage') },
      { name: 'Memory Usage', type: 'line', data: makeData('memory') },
      {
        name: 'CPU Temperature',
        type: 'line',
        data: makeData('cpu_temp_c'),
        yAxisIndex: 1, // other values are percentages, put this on a separate axis
        symbol: 'none',
      },
    ];
    const labels = series.map((s) => s.name);
    return {
      labels,
      series,
      timestamps,
      isEmpty: timestamps?.length === 0,
      latest: deployment?.last_heartbeat,
    };
  }
)(HeartbeatsGraph);
